import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteProcedimentoCadastro } from '../service';
import {
  DELETE_PROCEDIMENTO_CADASTRO,
  DELETE_PROCEDIMENTO_CADASTRO_PENDING,
  DELETE_PROCEDIMENTO_CADASTRO_SUCCESS,
  DELETE_PROCEDIMENTO_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteProcedimentoCadastro(action) {
  yield put({ type: DELETE_PROCEDIMENTO_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.PROCEDIMENTO_AGRICOLA_EXCLUIR);

  try {
    const a = yield call(deleteProcedimentoCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PROCEDIMENTO_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PROCEDIMENTO_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteProcedimentoCadastro() {
  yield takeLatest(DELETE_PROCEDIMENTO_CADASTRO, sagaDeleteProcedimentoCadastro)
}
